import React, { useState, useContext } from "react";
import PropTypes from "prop-types";

import CheckBox from "./CheckBox";

import { WidgetContext } from "./WidgetContext";

import { Colours } from "@learningblocks/shared-components";
import chevron from "./img/chevron.svg";

export default function Card(props) {
  const widget = useContext(WidgetContext);

  const [expanded, setExpanded] = useState(props.expanded);

  return (
    <div
      style={{
        background: "transparent",
        border: "1px solid " + Colours.navy1,
        borderRadius: "5px",
        width: "100%",
        boxSizing: "border-box",
        marginTop: "8px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between",
          padding: "16px",
          borderBottom:
            expanded && !props.action ? "1px solid " + Colours.navy1 : null,
        }}
      >
        <h4 tabIndex="0" style={{ color: Colours.charcoal1, margin: 0 }}>
          {props.heading}
        </h4>
        {props.action ? (
          <CheckBox
            value=""
            style={{ marginTop: 0 }}
            checked={widget.showTooltips}
            onChange={() => {
              widget.setShowTooltips(!widget.showTooltips);
            }}
            title=""
          />
        ) : (
          <button
            onClick={() => {
              setExpanded(!expanded);
            }}
            style={{
              background: "none",
              border: "none",
              marginLeft: "8px",
              cursor: "pointer",
            }}
          >
            <img
              alt="Up chevron"
              src={chevron}
              style={{
                pointerEvents: "none",
                transform: !expanded ? "rotate(180deg)" : null,
              }}
            />
          </button>
        )}
      </div>
      <div
        style={{
          padding: "16px",
          color: Colours.navy1,
          display: expanded && !props.action ? null : "none",
          fontSize: "14px",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}
Card.PropTypes = {
  expanded: PropTypes.boolean,
  heading: PropTypes.string,
  children: PropTypes.object,
  action: PropTypes.function,
};
